import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable, runInAction } from "mobx";
import { __ } from "../utils/i18n.js";
import { request } from "../utils/request.js";
import { locationRestScannerResultIgnorePost } from "../wp-api/scannerResultIgnore.post.js";
class ScannerResultExternalUrl {
    get identifier() {
        return this.data.host;
    }
    get inactive() {
        return this.blockedStatus === "full" || this.data.ignored;
    }
    get blockedStatus() {
        const { foundCount, blockedCount } = this.data;
        return blockedCount === 0 ? "none" : foundCount === blockedCount ? "full" : "partial";
    }
    get blockedStatusText() {
        switch(this.blockedStatus){
            case "full":
                return __("Fully blocked");
            case "partial":
                return __("Partially blocked");
            default:
                return __("Not blocked");
        }
    }
    constructor(externalUrl, store){
        this.busy = false;
        this.ignore = flow(function*(state) {
            this.busy = true;
            try {
                yield request({
                    location: locationRestScannerResultIgnorePost,
                    request: {
                        type: "host",
                        value: this.data.host,
                        ignored: state
                    }
                });
                this.data.ignored = state;
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busy = false;
            }
        });
        runInAction(()=>{
            this.data = externalUrl;
        });
        this.store = store;
    }
}
_ts_decorate([
    observable
], ScannerResultExternalUrl.prototype, "busy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], ScannerResultExternalUrl.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ScannerResultExternalUrl.prototype, "identifier", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ScannerResultExternalUrl.prototype, "inactive", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ScannerResultExternalUrl.prototype, "blockedStatus", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ScannerResultExternalUrl.prototype, "blockedStatusText", null);
export { ScannerResultExternalUrl };
